import { render, staticRenderFns } from "./VipPage.vue?vue&type=template&id=7fb6ceca&scoped=true&"
import script from "./VipPage.vue?vue&type=script&lang=js&"
export * from "./VipPage.vue?vue&type=script&lang=js&"
import style0 from "./VipPage.vue?vue&type=style&index=0&id=7fb6ceca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb6ceca",
  null
  
)

export default component.exports